import { API } from 'aws-amplify';

export const read = async () => API.get('eventmanagerUserApi', '/events', {});

export const readOne = async (id) => API.get('eventmanagerUserApi', `/events/${id}`, {});

export const addGuests = async (id, guests) =>
  API.put('eventmanagerUserApi', `/events/${id}/guests`, {body: {guests}});

export const readGuests = async (id) => API.get('eventmanagerUserApi', `/events/${id}/guests`, {});
